import React from 'react';
import {PropTypes} from 'prop-types';
import {Grid} from '@material-ui/core';
import './ImageViewerHeader.scss';

export const ImageViewerHeader = ({right}) => {
  return (
    <Grid container className="image-viewer-header">
      <Grid item className="image-viewer-header__right" xs={12} sm={6}>
        {right}
      </Grid>
    </Grid>
  );
};

ImageViewerHeader.propTypes = {
  right: PropTypes.any,
};

ImageViewerHeader.defaultProps = {
  right: undefined,
};
